import { ContenidoEffect } from 'src/app/store/effects/content-effect/content.effect';
import { MaestrosEffect } from 'src/app/store/effects/maestros-effect/maestros.effect';
import { PagoEffect } from 'src/app/store/effects/pago-effect/pago.effect';

export const effectsArray: any[] = [
  ContenidoEffect,
  MaestrosEffect,
  PagoEffect,
];
